/* unplugin-vue-components disabled */import { render } from "./service.vue?vue&type=template&id=471b1b7e"
import script from "./service.vue?vue&type=script&lang=js"
export * from "./service.vue?vue&type=script&lang=js"

import "./service.vue?vue&type=style&index=0&id=471b1b7e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__